@defer {
  <idoc-pwa-install-prompt />
}
<router-outlet></router-outlet>
<ng-container *ngComponentOutlet="feedbackModal$()"></ng-container>
<ng-container *ngComponentOutlet="paymentRequiredModal$()"></ng-container>
